<app-menu-crud-panel-bot [rows]="recordRowsLogs" [conf]="recordConfBtns" [btns]="btnsL">
	<div PanelContent>
		<div class="w-full h-full">
			<textarea placeholder="Notes" class="crud-input-textarea" [(ngModel)]="svcMenuCrudBody.note"></textarea>
		</div>
	</div>
</app-menu-crud-panel-bot>